import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FieldArray, formValueSelector, reduxForm, getFormError } from 'redux-form';
import { get } from 'lodash';
import Travellers from '../../../Travellers/Travellers';
import { Button } from '../../../../../../common/components/index';
import ButtonBar from '../../../../../../common/components/ButtonBar/ButtonBar';
import uuid from 'uuid/v4';
const TAX_EXEMPT_POSTCODES = ['BF', 'GX', 'GY', 'IM', 'JE'];
export class TravellersDetailsTab01 extends Component {
  constructor(props) {
    super(props);
    this.updateAge = this.updateAge.bind(this);
  }

  updateAge(travellerAge, travellerNumber, child) {
    const { change, dispatch } = this.props;
    if (child) {
      dispatch(
        change(
          'data.attributes.metadata.children[' + travellerNumber + '].age',
          travellerAge,
        ),
      );
    } else {
      dispatch(
        change(
          'data.attributes.metadata.adults[' + travellerNumber + '].age',
          travellerAge,
        ),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    let leadAdultLastName = get(
      nextProps.formValues,
      'data.attributes.metadata.adults[0].last_name',
      false,
    );

    const adults = get(nextProps.formValues, 'data.attributes.metadata.adults', []);
    adults &&
      adults.map((adult) => {
        if (get(adult, 'same_last_name', false) && leadAdultLastName) {
          return (adult.last_name = leadAdultLastName);
        }
      });
    const children = get(nextProps.formValues, 'data.attributes.metadata.children', []);

    children &&
      children.map((child) => {
        if (get(child, 'same_last_name', false) && leadAdultLastName) {
          return (child.last_name = leadAdultLastName);
        }
      });
  }

  renderAddChildTravellerButton() {
    const { formValues } = this.props;
    const children = get(formValues, 'data.attributes.metadata.children', []).length;
    const adults = get(formValues, 'data.attributes.metadata.adults', []).length;
    const travellerGroup = get(formValues, 'data.attributes.metadata.traveller_group');
    if (adults + children > 9) {
      return false;
    }
    if (travellerGroup === 'couple') {
      return false;
    }
    if (travellerGroup === 'group' && adults < 10) {
      return true;
    }
    return !(travellerGroup === 'family' && children > 3);
  }

  renderAddAdultTravellerButton() {
    const { formValues } = this.props;
    const adults = get(formValues, 'data.attributes.metadata.adults', []).length;
    const children = get(formValues, 'data.attributes.metadata.children', []).length;
    const travellerGroup = get(formValues, 'data.attributes.metadata.traveller_group');

    if (travellerGroup === 'individual' && adults + children < 10) {
      return true;
    }
    if (travellerGroup === 'couple' && adults < 2) {
      return true;
    }
    if (travellerGroup === 'group' && children < 10) {
      return true;
    }
    return travellerGroup === 'family' && adults < 2;
  }

  handleMoveChildToAdult = (option, childPath, childIndex) => {
    this.moveChildToAdult(option, childPath, childIndex);
  };

  moveChildToAdult(option, childPath, childIndex) {
    const { formValues, array, dispatch, change } = this.props;
    const child = get(formValues, 'data.' + childPath);
    if (option === 'mvToAdult') {
      array.push('data.attributes.metadata.adults', child);
      array.remove('data.attributes.metadata.children', childIndex);
      dispatch(change('data.attributes.metadata.traveller_group', 'individual'));
    }
  }

  addTravellerAdult = () => {
    const { array, dispatch, change } = this.props;

    let travellerDetails = {
      title: travellerDefaults.title,
      first_name: travellerDefaults.first_name,
      last_name: travellerDefaults.last_name,
      dob: travellerDefaults.dob,
      email: travellerDefaults.email,
      phone1: travellerDefaults.phone1,
      phone2: travellerDefaults.phone2,
      conditions_covered: travellerDefaults.conditions_covered,
      screening: travellerDefaults.screening,
      screening_id: travellerDefaults.screening_id,
      sanction_id: uuid(),
      sanctions_check: travellerDefaults.sanctions_check,
      age: travellerDefaults.age,
      same_last_name: travellerDefaults.same_last_name,
    };

    array.push('data.attributes.metadata.adults', travellerDetails);
    dispatch(change('data.attributes.metadata.sanctions_check_complete', false));
  };

  addTravellerChild = () => {
    const { array, dispatch, change } = this.props;

    let travellerDetails = {
      title: travellerDefaults.title,
      first_name: travellerDefaults.first_name,
      last_name: travellerDefaults.last_name,
      dob: travellerDefaults.dob,
      email: travellerDefaults.email,
      phone1: travellerDefaults.phone1,
      phone2: travellerDefaults.phone2,
      conditions_covered: travellerDefaults.conditions_covered,
      screening: travellerDefaults.screening,
      screening_id: travellerDefaults.screening_id,
      sanction_id: uuid(),
      sanctions_check: travellerDefaults.sanctions_check,
      age: travellerDefaults.age,
      same_last_name: travellerDefaults.same_last_name,
    };

    array.push('data.attributes.metadata.children', travellerDetails);
    dispatch(change('data.attributes.metadata.sanctions_check_complete', false));
  };

  handlePostcodeChange = (value) => {
    const { dispatch, change } = this.props;

    const postcodePrefix = value
      .trim()
      .substring(0, 2)
      .toUpperCase();
    if (TAX_EXEMPT_POSTCODES.includes(postcodePrefix)) {
      dispatch(change('data.attributes.metadata.options.smart_luggage', false));
    }
  };

  render() {
    const {
      formValues,
      currentProduct,
      openSpecificTab,
      handleSubmit,
      formErrors,
      isRenewal,
      auth,
    } = this.props;

    const DEFAULT_CHILDREN_MAX_AGE = 18;
    const childrenMaxAge = get(
      currentProduct,
      'data.attributes.metadata.children.max_age',
      DEFAULT_CHILDREN_MAX_AGE,
    );

    const loggedInUserEmail = get(auth, 'user.data.attributes.email', '');

    return (
      <div className="traveller-details-section">
        <FieldArray
          name="data.attributes.metadata.adults"
          formValues={get(formValues, 'data.attributes.metadata.adults')}
          travellerGroup={get(formValues, 'data.attributes.metadata.traveller_group')}
          numberOfTravellers={{
            adults: get(formValues, 'data.attributes.metadata.adults', []).length,
            children: get(formValues, 'data.attributes.metadata.children', []).length,
          }}
          leadAddress
          dobReadOnly
          change={this.props.change}
          goTab01={this.props.goTab01}
          disableAgeField={false}
          isRenewal={isRenewal}
          loggedInUserEmail={loggedInUserEmail}
          component={Travellers}
          onPostcodeChange={this.handlePostcodeChange}
        />

        <FieldArray
          name="data.attributes.metadata.children"
          formValues={get(formValues, 'data.attributes.metadata.children')}
          formErrors={formErrors}
          travellerGroup={get(formValues, 'data.attributes.metadata.traveller_group')}
          numberOfTravellers={{
            adults: get(formValues, 'data.attributes.metadata.adults', []).length,
            children: get(formValues, 'data.attributes.metadata.children', []).length,
          }}
          displayGroups={['family', 'individual', 'group']}
          currentProduct={currentProduct}
          child
          childrenMaxAge={childrenMaxAge}
          component={Travellers}
          handleMoveChildToAdult={this.handleMoveChildToAdult}
          numAdults={formValues?.data?.attributes?.metadata?.adults?.length + 1}
          isRenewal={isRenewal}
        />

        <ButtonBar>
          {this.renderAddAdultTravellerButton() && (
            <Button
              bsStyle="secondary"
              size="sm"
              label={'Add an Adult'}
              handleClick={this.addTravellerAdult}
            />
          )}
          {this.renderAddChildTravellerButton() && (
            <Button
              bsStyle="secondary"
              size="sm"
              label={'Add a Child'}
              handleClick={this.addTravellerChild}
            />
          )}
        </ButtonBar>
        <ButtonBar includeDivider={true}>
          <Button
            label="Next"
            id={'leisure-travel-btn-next'}
            className="pull-right btn-action"
            bsStyle="primary"
            handleClick={handleSubmit(() => openSpecificTab(2))}
          />
        </ButtonBar>
      </div>
    );
  }
}
const travellerDefaults = {
  title: '',
  first_name: '',
  last_name: '',
  dob: '',
  email: '',
  phone1: '',
  phone2: '',
  conditions_covered: true,
  screening: '',
  screening_id: '',
  sanction_id: '',
  sanctions_check: {},
  age: '',
  same_last_name: false,
};
const FORM_NAME = 'LeisureTravelForm';
const form = reduxForm({ form: FORM_NAME })(TravellersDetailsTab01);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state, props) => {
  const values = selector(state, 'data.id', 'data.attributes.metadata');

  return {
    auth: state.auth,
    initialValues: props.resource,
    formErrors: getFormError(FORM_NAME)(state),
    form: 'LeisureTravelForm',
    formValues: values,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    product: state.product,
  };
};

export default connect(mapStateToProps)(form);
